import { lazyLoad } from 'utils/loadable';

export const QuizRecordListPage = lazyLoad(
  () => import('./index'),
  module => module.QuizRecordListPage,
);
